import styled from "styled-components";

type LabelProps = {
  $hasError?: boolean;
};

const Label = styled.label<LabelProps>`
  align-self: stretch;
  color: ${(props) => (props.$hasError ? "#d32f2f" : "#000000")};
  font-family: Inter, Oxygen, Roboto, sans-serif;
  font-size: 14px;
  line-height: 20px;
  position: relative;
  text-align: left;
`;

export default Label;